import React, { useState, useEffect, useRef, useCallback } from "react";
import { withRouter } from "react-router-dom";

import { Bar } from "@ui5/webcomponents-react/lib/Bar";
import { Form } from "@ui5/webcomponents-react/lib/Form";
import { FormGroup } from "@ui5/webcomponents-react/lib/FormGroup";
import { FormItem } from "@ui5/webcomponents-react/lib/FormItem";
import { ComboBox } from "@ui5/webcomponents-react/lib/ComboBox";
import { ComboBoxItem } from "@ui5/webcomponents-react/lib/ComboBoxItem";
import { ValueState } from "@ui5/webcomponents-react/lib/ValueState";
import { Dialog } from "@ui5/webcomponents-react/lib/Dialog";
import { Button } from "@ui5/webcomponents-react/lib/Button";
import { Input } from "@ui5/webcomponents-react/lib/Input";
import MessageStripCompnt from "../../../shared/components/UIElements/MessageStrip";
import { setUserSession } from "../../../shared/utils/Common";

import "./LoginForm.css";

const axios = require("axios");

const LoginForm = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [database, setDatabase] = useState("");
  const [databaseList, setDatabaseList] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onUsernameInputHandler = (e) => {
    setUsername(e.parameters.value);
  };

  const onPasswordInputHandler = (e) => {
    setPassword(e.parameters.value);
  };

  const onCompanyChangeHandler = (e) => {
    setDatabase(e.parameters.value);
  };

  const getDatabaseList = async () => {
    await axios
      .get(`/api/auth/db/companies`)
      .then(function (response) {
        setDatabaseList(response.data.rows);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getDatabaseList();
  }, []);

  const loginHandler = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    await axios
      .post(`/api/auth/loginsl`, {
        username: username,
        password: password,
        companyName: database,
      })
      .then(function (response) {
        setLoading(false);
        setUserSession(
          response.data.token,
          response.data.user,
          response.data.companyName,
          response.data.companyDB
        );
        props.login();
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  return (
    <>
      <Dialog
        className="login__container"
        ref={props.dialogRef}
        stretch={false}
        headerText={"Login"}
        initialFocus={""}
        footer={
          <Bar
            contentRight={
              <Button type="button" onClick={loginHandler} disabled={loading}>
                {loading ? "Signing in..." : "Login"}
              </Button>
            }
          />
        }
        header={null}
      >
        <Form>
          <FormGroup>
            <FormItem label={"Username"}>
              <Input id="username" onInput={onUsernameInputHandler}></Input>
            </FormItem>
            <FormItem label={"Password"}>
              <Input
                id="password"
                type="Password"
                onInput={onPasswordInputHandler}
              ></Input>
            </FormItem>
            <FormItem label={"Company"}>
              <ComboBox
                disabled={false}
                filter={"StartsWithPerTerm"}
                filterValue={""}
                loading={false}
                placeholder={""}
                readonly={false}
                required={true}
                value={""}
                valueState={ValueState.None}
                onChange={onCompanyChangeHandler}
              >
                {databaseList.map((database) => (
                  <ComboBoxItem
                    key={database.DBNAME}
                    text={database.COMPANYNAME + " (" + database.DBNAME + ")"}
                  />
                ))}
              </ComboBox>
            </FormItem>
            {error && <MessageStripCompnt type="error" message={error} />}
          </FormGroup>
        </Form>
      </Dialog>
    </>
  );
};

export default withRouter(LoginForm);
